/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiPageHeader, EuiSpacer } from '@elastic/eui'

import AdminProjectList from '@modules/project-admin-components/ProjectList'
import { projectsCrumbs } from '@modules/project-admin-pages/breadcrumbs'
import Breadcrumbs from '@modules/cui/Breadcrumbs/Breadcrumbs'

type Props = unknown

const AdminProjectsPage: React.FunctionComponent<Props> = () => (
  <div>
    <Breadcrumbs breadcrumbs={projectsCrumbs()} />

    <EuiPageHeader
      bottomBorder={true}
      pageTitle={<FormattedMessage id='projects.page.list.title' defaultMessage='Projects' />}
    />

    <EuiSpacer />

    <AdminProjectList />
  </div>
)

export default AdminProjectsPage
